import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("教室情報の編集")
const _hoisted_2 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_3 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_4 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_5 = { class: "w-3/4 mx-auto text-center text-sm text-gray-500" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 教室と所属生徒を削除 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 変更を保存 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_text_field = _resolveComponent("m-text-field")
  const _component_m_multi_select_box = _resolveComponent("m-multi-select-box")
  const _component_m_button = _resolveComponent("m-button")
  const _component_m_base_modal = _resolveComponent("m-base-modal")

  return (_openBlock(), _createBlock(_component_m_base_modal, { onClose: _ctx.close }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_m_text_field, {
          label: "教室名",
          name: "name",
          type: "text",
          placeholder: "教室名を入力",
          value: _ctx.name,
          invalid: !_ctx.validName,
          "invalid-message": "教室名は入力必須です",
          entered: "",
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.name = $event))
        }, null, 8, ["value", "invalid"])
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_m_text_field, {
          label: "教室ID (重複不可)",
          name: "id",
          type: "text",
          placeholder: "半角英数字2文字以内",
          value: _ctx.id,
          invalid: !_ctx.validId,
          "invalid-message": "教室IDは半角英数字2文字以上で入力してください。また他の教室と同じIDは使用できません。",
          entered: "",
          onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.id = $event))
        }, null, 8, ["value", "invalid"])
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_m_multi_select_box, {
          label: 
            `権限を持つスタッフ一覧 ( ${
              _ctx.isSchool ? '管理職・ICT担当者' : 'オーナー・管理者'
            } 権限のスタッフを除く)`
          ,
          name: "tutors",
          placeholder: _ctx.tutorsPlaceholder,
          options: _ctx.tutorsExceptAdminAndOwner,
          values: _ctx.selectTutors,
          "text-key": "main.data.name",
          "primary-key": "main.ref.id",
          onChange: _ctx.changeTutor
        }, null, 8, ["label", "placeholder", "options", "values", "onChange"])
      ]),
      _createVNode("div", _hoisted_5, _toDisplayString(`※${
            _ctx.isSchool ? "「管理職」「ICT担当者」" : "「オーナー」「管理者」"
          }権限を持つスタッフは全ての教室の確認権限を持ちます`), 1)
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_m_button, {
        color: "red-400",
        "hover-color": "red-500",
        outline: "",
        class: "mr-4",
        onClick: _ctx.deleteClassroom
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_m_button, {
        color: "primary-500",
        "hover-color": "primary-600",
        disabled: !_ctx.validData,
        onClick: _ctx.update
      }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _: 1
  }, 8, ["onClose"]))
}